<!-- 绑定收货地址 -->
<template>
  <popup-frame ref="address" size="lg" @close="$emit('close')">
    <div :class="$style.address">
      <p style="font-size: 0.28rem; text-align: center; line-height: 1.3">
        恭喜你抽中了<em>【{{ prizeName }}】</em><br />请填写您的收货信息。
      </p>
      <form autocomplete="off" @submit.prevent="handleSubmit" :class="$style.form">
        <!-- 收货人姓名 -->
        <div :class="$style.field">
          <input
            v-model="name"
            :maxlength="10"
            :readonly="isLocked"
            placeholder="请输入收货人姓名"
            :class="$style['field-input']"
          />
        </div>
        <!-- 收货人手机号码 -->
        <div :class="$style.field">
          <input
            v-model="phone"
            type="tel"
            maxlength="11"
            :readonly="isLocked"
            placeholder="请输入收货人手机号码"
            :class="$style['field-input']"
          />
        </div>
        <!-- 收货人地址 -->
        <div :class="$style.field">
          <input
            v-model="address"
            :maxlength="100"
            :readonly="isLocked"
            placeholder="请输入收货人地址"
            :class="$style['field-input']"
          />
        </div>
        <div v-if="!isLocked" style="text-align: center">
          <button :class="$style['btn-submit']" />
        </div>
      </form>
      <p
        v-if="!isChannel"
        style="margin-top: 0.2rem; font-size: 0.2rem; line-height: 1.5; color: #5360d5"
      >
        * 确认后如果需要更改请在《命运圣契》微信公众号后台联系人工客服。
      </p>
    </div>
  </popup-frame>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { PopupFrame } from '@/components/widgets'
import { bindAddress } from '@/api'

export default {
  name: 'TheBindAddress',
  components: { PopupFrame },
  data() {
    return {
      /** 是否锁定表单, 锁定后无法提交数据 */
      isLocked: false,
      /** 联系人 */
      name: null,
      /** 联系电话 */
      phone: null,
      /** 联系地址 */
      address: null,
      /** 奖品名称 */
      prizeName: ''
    }
  },
  computed: {
    ...mapGetters(['addressData', 'isChannel'])
  },
  mounted() {
    if (Object.keys(this.addressData).length) {
      this.handleInit(this.addressData)
    }
  },
  watch: {
    addressData: {
      handler: function () {
        if (Object.keys(this.addressData).length) {
          this.handleInit(this.addressData)
        } else {
          this.handleInit()
        }
      }
    }
  },
  methods: {
    ...mapActions(['setAddressData']),
    async handleInit(data) {
      if (data) {
        const { address, name, tel } = data
        this.isLocked = true
        this.name = name
        this.phone = tel
        this.address = address
      } else {
        this.isLocked = false
        this.name = ''
        this.phone = ''
        this.address = ''
      }
    },
    async handleSubmit() {
      if (!this.verifyData()) {
        const data = {
          tel: this.phone,
          name: this.name,
          address: this.address
        }
        const { code, msg } = await bindAddress(data)
        if (code === 0) {
          this.$toast(msg)
          this.isLocked = true
          this.setAddressData(data)
        }
      }
    },
    verifyData() {
      if (!this.name) {
        return this.$toast('请输入收货人姓名')
      } else if (!this.phone) {
        return this.$toast('请输入收货人手机号码')
      } else if (!/^1\d{10}$/.test(this.phone)) {
        return this.$toast('请输入有效的收货人手机号码')
      } else if (!this.address) {
        return this.$toast('请输入收货人地址')
      }
      return false
    },
    show(prizeName) {
      this.prizeName = prizeName
      this.$refs.address.show()
    }
  }
}
</script>

<style lang="less" module>
@input-width: 5.62rem;
@input-height: 0.87rem;

.address {
  padding-top: 0.1rem;

  &::before {
    .size(7.5rem,3.37rem);
    .background-fill('./images/title.png');

    content: '';
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }
}

.form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 4.8rem;
}

/* 输入项 */
.field {
  .size(@input-width, @input-height);
  .background-fill('./images/field-bg.png', 100% 100%);

  position: relative;
  margin-bottom: 0.25rem;

  &-input {
    .size(100%);

    border: 0;
    padding: 0 0.25rem 0 0.65rem;
    background-color: transparent;
    color: #fff;

    &::placeholder {
      color: fade(#fff, 50%);
    }
  }
}

/* 表单提交按钮 */
.btn-submit {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/btn-submit.png');

  &[disabled] {
    opacity: 0.5;
    cursor: default;
  }
}
</style>
